import ApiService from "./api.service";

const ProcedimentoService = {
  async getProcedimentos(params) {
    return await ApiService.get("/procedimentos", params);
  },

  async getProcedimento(id) {
    return await ApiService.get(`/procedimentos/${id}`);
  },

  async salvar(procedimento) {
    return await ApiService.post("/procedimentos/salvar", procedimento);
  },

  async excluir(id) {
    return await ApiService.get(`/procedimentos/excluir/${id}`);
  },
};

export default ProcedimentoService;
